module.exports = __webpack_public_path__ + "static/media/xdai.e37299a8.png";